// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2XRIp","noInteraction":"EventWrapper_noInteraction__343iU"};